/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-shadow */
import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Form as BForm, Modal, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import TextInput from "../../../../../components/formfields/InputField";

const formSchema = Yup.object({
  title: Yup.string().required("Title can not be empty"),
  description: Yup.string().required("Description can not be empty"),
  // link: Yup.string().required("Link can not be empty"),
  image: Yup.string().required("Image can not be empty"),
});

function AddFeatureModal({ show, setShow, customArrayHelper, uploadAction, editData, setFieldValue, index }: any) {
  const [loading, setLoading] = useState(false);
  const addState = {
    title: editData ? editData.title : "",
    subTitle: editData ? editData.subTitle : "",
    description: editData ? editData.description : "",
    image: editData ? editData.image : "",
  };

  const handleSubmit = (values: any, { resetForm }: any) => {
    if (editData) {
      setFieldValue(`features[${index}]`, { ...values });
      setShow(false);
    } else {
      customArrayHelper.push({ ...values });
      resetForm();
      setShow(false);
    }
  };

  const handleUpload = (event: any, fieldValue: any, name: string) => {
    const data = {
      file: event.currentTarget.files[0],
    };
    uploadAction(data, fieldValue, name, setLoading);
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {
        setShow(false);
      }}
      className="resource_library_modal"
      scrollable
    >
      <Formik enableReinitialize initialValues={addState} validationSchema={formSchema} onSubmit={handleSubmit}>
        {({ values, handleChange, handleBlur, setFieldValue }: any) => {
          return (
            <Form className="modal-content h-100">
              <Modal.Header closeButton>
                <Modal.Title className="fw-bold h6">Add Feature</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="gy-3">
                  <Col lg="6">
                    <BForm.Label>Title</BForm.Label>
                    <Field
                      name="title"
                      component={TextInput}
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Title"
                      className="editField"
                    />
                  </Col>
                  <Col lg="6">
                    <BForm.Label>Sub Title</BForm.Label>
                    <Field
                      name="subTitle"
                      component={TextInput}
                      value={values.subTitle}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Subtitle"
                      className="editField"
                    />
                  </Col>
                  <Col xs="12">
                    <BForm.Label>Description</BForm.Label>
                    <Field
                      name="description"
                      component={TextInput}
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Description"
                      className="editField"
                      multiline
                    />
                  </Col>
                  <Col sm={6}>
                    <BForm.Label>Upload Image</BForm.Label>
                    <div className="uploarForm position-relative square overflow-hidden">
                      {values.image ? (
                        <>
                          <button
                            type="button"
                            aria-hidden="true"
                            className="btn btn-danger btn-sm btn-icon position-absolute top-0 end-0 rounded me-2 mt-2 zindex-1"
                            onClick={() => {
                              setFieldValue("image", "");
                            }}
                          >
                            <i className="fa-regular fa-trash-can" />
                          </button>

                          <img className="img-fluid position-absolute fitImage h-100 top-0" src={values.image} alt="imagessss" />
                        </>
                      ) : loading ? (
                        <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                          <i className="fa-light fa-circle-notch fa-spin fa-2x text-primary" />
                          <h6 className="mb-0 mt-3">Loading...</h6>
                        </div>
                      ) : (
                        <>
                          <input
                            id="file"
                            name="image"
                            type="file"
                            accept="image/x-png,image/gif,image/jpeg"
                            onChange={(e) => handleUpload(e, setFieldValue, "image")}
                          />
                          <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                            <i className="fa-light fa-upload fa-2x text-primary" />
                            <h6 className="mb-0 mt-3">Upload Image</h6>
                          </div>
                        </>
                      )}

                      <ErrorMessage name="image" className="errorMessage" component="div" />
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <button type="submit" className="addNewItem">
                  {editData ? "Update" : "Add"}
                </button>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default AddFeatureModal;
